import { useEffect, useState } from 'react';
import '../css/ListarPilotoMototaxi.css';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';

import { buscarPilotosDeMototaxiByPonto } from '../servicos/listagemServico';
import { excluirPilotoMototaxi } from '../servicos/exclusaoServico';

function ListarPilotoMototaxi() {

  const [pilotos, setPilotos] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {

    console.log('-----------------');
    console.log('Entrou no useEffect do ListarPilotoMototaxi.js....');

    const carregarPilotos = async () => {
      try {
        const cookies = Cookies.get();
        const dadosCookies = cookies.dadosCookies ? JSON.parse(cookies.dadosCookies) : null;
        const dadosPontoMototaxi = dadosCookies.dadosPontoMototaxi;
        const idPontoMototaxi = dadosPontoMototaxi.id;

        console.log('dadosCookies: ');
        console.log(dadosCookies);

        console.log('cookies: ');
        console.log(cookies.dadosCookies);

        console.log('id do ponto: ');
        console.log(idPontoMototaxi);

        if (!dadosCookies || !dadosCookies.dadosPontoMototaxi?.id) {
          alert("Erro: dados do ponto não encontrados.");
          return;
        }

        // const idRepresentante = dadosCookies.dadosRepresentanteComercial.id;

        console.log('preparando pra buscar os pilotos do ponto...');

        const resposta = await buscarPilotosDeMototaxiByPonto(dadosCookies);

        console.log('Resposta: ');
        console.log(resposta);

        console.log('Pilotos: ');
        console.log(resposta.pilotos);


        setPilotos(resposta.pilotos); // Espera um array de objetos

      } catch (erro) {
        console.error("Erro ao buscar pilotos:", erro);
        alert("Erro ao buscar pilotos cadastrados.");
      }
    };

    carregarPilotos();
  }, []);



  const handleExcluir = async (id) => {
    const confirmado = window.confirm('Tem certeza que deseja excluir este piloto?');
    if (!confirmado) return;

    try {
      await excluirPilotoMototaxi(id);
      // Atualiza a lista após a exclusão
      setPilotos(pilotos.filter((piloto) => piloto.id !== id));
      navigate('/pagina-ponto-mototaxi');
      
    } catch (error) {
      alert('Erro ao excluir piloto: ' + error.message);
    }
  };



  return (
    <div className="listar-piloto-mototaxi">
      <div className="card p-4 shadow-sm" style={{ width: '100%', maxWidth: '800px', margin: '2rem auto' }}>
        <div className="card-body">
          <h3 className="text-center mb-4">Pilotos Cadastrados</h3>

                <button 
                  className="btn btn-primary btn-sm"
                  onClick={() => navigate("/visualizar-pilotos-no-mapa")}
                >
                  Visualizar pilotos no mapa
                </button>
                <br /><br />



          {pilotos.length === 0 ? (
            <p className="text-center">Nenhum piloto encontrado.</p>
          ) : (
            <div className="lista-pilotos">

              {/* esses pilotos na verdade são da tabela piloto do ponto. o piloto mesmo é objPiloto */}
              {pilotos.map((piloto) => (
                <div key={piloto.objPiloto.id} className="piloto-item mb-4 p-3 border rounded">
                  <p><strong>Nome do piloto:</strong> {piloto.objUser.name}</p>
                  <p><strong>Email do piloto:</strong> {piloto.objUser.email}</p>
                  <p><strong>Telefone do piloto:</strong> {piloto.objPiloto.numero_celular_com_ddd}</p>
                  <p><strong>Status do piloto:</strong> {piloto.objStatusPiloto?.nome}</p>
                  <p><strong>Início vigência:</strong> {piloto.data_inicio_vigencia}</p>
                  <p><strong>Fim vigência:</strong> {piloto.data_fim_vigencia}</p>

                  <p><strong>Serviços Atendidos:</strong></p>
                  <p>
                    {
                      piloto.arrayServicosAtendidosPeloPiloto.map((servico) => (
                        <>
                          {servico.nome}, 
                        </>
                      ))                    
                    }
                  </p>
                  <button onClick={() => handleExcluir(piloto.objPiloto.id)}>
                    Excluir Piloto
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ListarPilotoMototaxi;
